import { call, put, select } from 'redux-saga/effects';
import API from "../../API";
import {loadWordVerbatimsError, loadWordVerbatimsSuccess} from "./word-verbatims-action-creators";
import {paginate} from "../charts/functions";
import {prepareFiltersToSend} from "../filters/functions";


export default function* loadWordVerbatims() {

  const reportUrl = yield select(state => state.report.reportUrl);
  const filters = yield select(state => state.filters.filtersToSend);
  const word = yield select(state => state.wordVerbatims.word);

  try {
    const result = yield call(API.loadWordVerbatims,
      {
      reportUrl,
      filters,
      word
      }
    );
    console.log(result, 'RESULT FROM LOAD WORD VERBATIMS REQUEST');
    if (result.data.results && result.data.results.length) {

      const { general, negation } = normalize(result.data.results);

      let paginatedGeneral;
      let paginatedNegation;

      general ? paginatedGeneral = paginate(general.values, 15) : paginatedGeneral = {};
      negation ? paginatedNegation = paginate(negation.values, 15) : paginatedNegation = {};

      yield put(loadWordVerbatimsSuccess({ general: paginatedGeneral, negation: paginatedNegation }))

    } else {
      yield put(loadWordVerbatimsError("No data"))
    }
  } catch(error) {
    console.log(error, 'ERROR FROM LOAD WORD VERBATIMS REQUEST');
    yield put(loadWordVerbatimsError("Something went wrong..."))
  }
}

const normalize = data => {
  const general = data.filter(d => d.context === 'general')[0] || null;
  const negation = data.filter(d => d.context === 'negation')[0] || null;
  return {
    general,
    negation
  }
};



// WEBPACK FOOTER //
// ./src/modules/word-verbatims/load-word-verbatims-saga.js